// src/utils/jwt.js
import { jwtDecode } from 'jwt-decode';

export const decodeToken = (token) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const getUserFromToken = (token) => {
  const decoded = decodeToken(token);
  if (!decoded) return null;

  // Normalize roles into [{ name, resource_type, resource_id }]
  let roles = [];
  if (Array.isArray(decoded.role)) {
    roles = decoded.role
      .filter(r => r && r.name)
      .map(r => ({
        name: r.name,
        resource_type: r.resource_type,
        resource_id: r.resource_id
      }));
  } else if (decoded.role && typeof decoded.role === 'string') {
    roles = [{ name: decoded.role }];
  }

  const primary = roles[0] || null;

  return {
    id: decoded.sub || decoded.id,
    email: decoded.email,
    name: decoded.user_name,
    role: primary?.name || null,            // backward compatible
    roles,                                  // full roles array
    medical_center_id: primary?.resource_id || null,
    first_name: decoded.first_name,
    last_name: decoded.last_name
  };
};

export const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  
  const currentTime = Date.now() / 1000;
  return decoded.exp < currentTime;
};